export default {
	chip: {
		dateRange: {
			onlyFrom: 'Depuis le',
			onlyTo: 'Jusqu\'au',
			from: 'Du',
			to: 'au',
			fromGreaterThanTo: 'La date de début doit être inférieure à la date de fin.'
		},
		paymentAmount: {
			invalidAmount: 'Veuillez entrer un montant valide.'
		}
	}
};
